import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Module } from 'app/core/application/features/interfaces/module.interface';

@Injectable()
export class ModuleService {

    constructor(private _http: HttpClient) {}

    loadConfig(): Promise<Module[]> {
        return this._http.get<Module[]>('./assets/modules.json').toPromise();
    }

}